import { FastForward, FastRewind, MusicNote, PauseCircleFilled, PlayCircleFilled, QueueMusic, SkipNext, SkipPrevious, VolumeMute, VolumeOff } from '@material-ui/icons'
import ProgressBar from 'components/media/ProgressBar'
import { ACCESS_TYPES } from 'components/vortex/CreateVortexRoom'
import Marquee from 'react-fast-marquee'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { isSignedIn } from 'redux/actions/accountActions'
import { setContinuousPlay } from 'redux/actions/displayActions'
import { setUserInteracted } from 'redux/actions/playerControlActions'
import { setUserStartedPlayback } from 'redux/actions/playerControlActions'
import { setUserPausedMedia } from 'redux/actions/playerControlActions'
import { setUserMutedMedia } from 'redux/actions/playerControlActions'
import { setVideoPlaying } from 'redux/actions/playerControlActions'
import { ANALYTICS_EVENTS, track } from 'util/analyticsUtil'
import { getCurrentPlaylistEntry } from 'util/playlistUtils'

export default function PlayerControls({ mute, unmute, play, pause,
    rewind, forward, mediaRef, controlRef }) {

    const { mediaDuration, hideControls, preview } = useSelector(state => state.playerControls)
    const { controlColumnOpacity } = useSelector(state => state.settings)
    const { continuousPlay, reactorPlay } = useSelector(state => state.display)
    const history = useHistory()

    const controlStyles = {
        control: {
            fontSize: '40px',
            width: '40px',
            height: '40px',
            color: 'white'
        }
    }

    const dispatch = useDispatch()

    const displayContinuousPlay = () => {
        return (
            <>

                {continuousPlay ? <QueueMusic style={controlStyles.control} onClick={(evt) => {
                    evt.stopPropagation()
                    dispatch(setContinuousPlay(false))
                    dispatch(setUserInteracted(true))
                }} />
                    : <MusicNote style={controlStyles.control} onClick={(evt) => {
                        evt.stopPropagation()
                        dispatch(setContinuousPlay(true))
                        dispatch(setUserInteracted(true))
                    }} />}
            </>)
    }

    /*
    const displayCostToPlay = () => {
        return Intl.NumberFormat('en-US',
            { minimumIntegerDigits: 1, maximumFractionDigits: 0 }).format(mediaDuration / 60)
    }
    */

    const displayScrollingPreviews = () => {
        const song = getCurrentPlaylistEntry()
        if (song) {
            const { accessType, firstName, lastName, handle } = song
            const freePlay = accessType === ACCESS_TYPES.PUBLIC
            if (preview || freePlay) {
                const message = freePlay ? `Free playback courtesy of ${firstName} ${lastName} @${handle}` : 'Playing previews....CLICK HERE to play full songs and videos'
                return (
                    <Marquee>
                        <div
                            onClick={() => {
                                if (process.env.REACT_APP_USE_PROMOTIONAL_CREDITS === 'true'
                                    && !isSignedIn()
                                ) {
                                    history.push('/SignIn')
                                } else {
                                    history.push('/Pricing')
                                }
                            }
                            }
                            style={{
                                color: 'white',
                                fontStyle: 'italic', fontWeight: 'bold', fontSize: '1.5em'
                            }}>&nbsp;...{message}...&nbsp;</div></Marquee>
                )
            }
        }
    }
    /**
     * We think we need to maintain a separate control state on ios because 
     * the video has to start muted and unmuting it is not related to the
     * audio mute...
     * @returns 
     */
    const getMutedControl = () => {
        //console.log(`PlayerControls getMutedCOntrol mediaRef.current `, mediaRef.current)
        if (mediaRef.current) {
            //console.log(`...mediaRef.current.muted ${mediaRef.current.muted}`)
            return (
                <>
                    {mediaRef.current.muted ?
                        <VolumeOff style={controlStyles.control} onClick={() => {
                            dispatch(setUserMutedMedia(false))
                            dispatch(setUserInteracted(true))
                            track(ANALYTICS_EVENTS.UNMUTE)
                            unmute()
                        }} /> :
                        <VolumeMute style={controlStyles.control} onClick={() => {
                            dispatch(setUserMutedMedia(true))
                            dispatch(setUserInteracted(true))
                            track(ANALYTICS_EVENTS.MUTE)
                            mute()
                        }}
                        />}
                </>
            )
        }
    }
    const getPlayControl = () => {
        if (mediaRef.current) {
            return (
                <>
                    {mediaRef.current.paused ? <PlayCircleFilled style={controlStyles.control} onClick={() => {
                        dispatch(setVideoPlaying(true))
                        dispatch(setUserPausedMedia(false))
                        dispatch(setUserInteracted(true))
                        dispatch(setUserStartedPlayback(true))
                        play()
                    }} /> :
                        <PauseCircleFilled style={controlStyles.control} onClick={() => {
                            dispatch(setVideoPlaying(false))
                            dispatch(setUserPausedMedia(true))
                            dispatch(setUserInteracted(true))
                            pause()
                        }}
                        />}
                </>
            )
        }

    }
    const controls = () => {
        //console.log(`PlayerControls hideControls ${hideControls}`)
        if (!hideControls) {
            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%', justifyContent: 'center',
                    position: 'fixed', bottom: 0, left: 0, padding: '10px 15px',
                    backgroundColor: reactorPlay ? 'black' : `rgba(0,0,0,${controlColumnOpacity < 0.05 ? 0.05 : controlColumnOpacity})`
                }}>
                    {displayScrollingPreviews()}
                    <ProgressBar mediaRef={mediaRef} mediaDuration={mediaDuration} />
                    <div style={{
                        display: 'flex', width: '100%', justifyContent: 'space-between',
                        alignItems: 'center'
                    }}>
                        {getMutedControl()}
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <SkipPrevious style={controlStyles.control}
                                onClick={() => {
                                    controlRef.current.previousMedia()
                                    dispatch(setUserInteracted(true))
                                }}
                            />
                            <FastRewind style={controlStyles.control}
                                onClick={() => {
                                    rewind()
                                    dispatch(setUserInteracted(true))
                                }} />
                            {play && pause ? getPlayControl() : null}
                            <FastForward style={controlStyles.control}
                                onClick={() => {
                                    forward()
                                    dispatch(setUserInteracted(true))
                                }
                                }
                            />
                            <SkipNext style={controlStyles.control}
                                onClick={() => {
                                    controlRef.current.nextMedia()
                                    dispatch(setUserInteracted(true))
                                }
                                } />
                        </div>
                        {displayContinuousPlay()}

                    </div>
                </div>
            )
        }
    }

    return controls()
}